import { render, staticRenderFns } from "./brands.vue?vue&type=template&id=0392993b&scoped=true&"
import script from "./brands.vue?vue&type=script&lang=js&"
export * from "./brands.vue?vue&type=script&lang=js&"
import style0 from "./brands.vue?vue&type=style&index=0&id=0392993b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0392993b",
  null
  
)

export default component.exports